import React, {FC} from 'react';

import {KeyboardActionsEnum} from '../../../../libs/shared/core/src/helpers/browser/keyboardHelpers';
import {InboxModel} from '../../../../libs/shared/core/src/models/api/inboxModel';
import {CellsContext} from '../../../../libs/shared/core/src/store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ConversationBaseModel} from '../../../models/api/conversationModel';
import {InboxesParameters} from '../../../store/panels/inboxes/parameters/inboxesParameters';
import {ConversationsTrashButtonProps} from '../viewer/conversation/actions/trash/conversationsTrashCoordinator';
import {ConversationTopbarTrash} from '../viewer/conversation/topbar/conversationTopbarTrash';
import {makeInboxesTopbarTrashTooltipProps} from './inboxesTopbarCommon';
import {InboxesTopbarTooltip} from './inboxesTopbarTooltip';

/*
 * Props.
 */

interface InboxesTopbarTrashProps {
  panelId: ViewerPanelId;
  cellsContext: CellsContext;
  inboxesParameters: InboxesParameters;
  conversationsInboxes: ReadonlyArray<InboxModel>;
  conversations: ReadonlyArray<ConversationBaseModel>;
  isBulkActionRequired: boolean;
}

/*
 * Component.
 */

export const InboxesTopbarTrash: FC<InboxesTopbarTrashProps> = (props) => {
  const renderTooltip = (trashProps: ConversationsTrashButtonProps) => {
    const tooltipProps = makeInboxesTopbarTrashTooltipProps(trashProps, props);
    return (
      <InboxesTopbarTooltip
        keyboardAction={KeyboardActionsEnum.TRASH}
        firstLine={tooltipProps.firstLine || tooltipProps.mainButton}
        secondLine={tooltipProps.secondLine}
      />
    );
  };

  return (
    <ConversationTopbarTrash
      panelId={props.panelId}
      cellsContext={props.cellsContext}
      inboxesParameters={props.inboxesParameters}
      conversations={props.conversations}
      isBulkActionRequired={props.isBulkActionRequired}
      renderTooltip={renderTooltip}
      isTooltipMultiline
    />
  );
};
